module.exports = __webpack_public_path__ + "static/media/energetic-icon.dd01679c.png";